/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassTypeInfo,
  ClassTypeInfoOptional,
  ClassTypeInfoMetaI,
  ClassTypeInfoTrackedI,
} from "./class-type-info";
import { ClassTypeInfoTracked, ClassTypeInfoMeta } from "./class-type-info";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassTypeRefWithName,
  ClassTypeRefWithNameOptional,
  ClassTypeRefWithNameMetaI,
  ClassTypeRefWithNameTrackedI,
} from "./class-type-ref-with-name";
import {
  ClassTypeRefWithNameTracked,
  ClassTypeRefWithNameMeta,
} from "./class-type-ref-with-name";
// May contain unused imports in some cases
// @ts-ignore
import type {
  RatingRefAndName,
  RatingRefAndNameOptional,
  RatingRefAndNameMetaI,
  RatingRefAndNameTrackedI,
} from "./rating-ref-and-name";
import {
  RatingRefAndNameTracked,
  RatingRefAndNameMeta,
} from "./rating-ref-and-name";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassTypeFull,
  UnifiedClassTypeFullOptional,
  UnifiedClassTypeFullMetaI,
  UnifiedClassTypeFullTrackedI,
} from "./unified-class-type-full";
import {
  UnifiedClassTypeFullTracked,
  UnifiedClassTypeFullMeta,
} from "./unified-class-type-full";

/**
 *
 * @export
 * @interface ClassTypeDTO
 */
export interface ClassTypeDTOOptional extends ClassTypeInfoOptional {
  /**
   *
   * @type {number}
   * @memberof ClassTypeDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof ClassTypeDTO
   */
  typeName?: string;
  /**
   *
   * @type {number}
   * @memberof ClassTypeDTO
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeDTO
   */
  prereqMustComplete?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeDTO
   */
  allowTeacher?: boolean;
  /**
   *
   * @type {RatingRefAndName}
   * @memberof ClassTypeDTO
   */
  teachRating?: RatingRefAndNameOptional;
  /**
   *
   * @type {RatingRefAndName}
   * @memberof ClassTypeDTO
   */
  ratingPrereq?: RatingRefAndNameOptional;
  /**
   *
   * @type {RatingRefAndName}
   * @memberof ClassTypeDTO
   */
  ratingOverkill?: RatingRefAndNameOptional;
  /**
   *
   * @type {ClassTypeRefWithName}
   * @memberof ClassTypeDTO
   */
  classPrereq?: ClassTypeRefWithNameOptional;
  /**
   *
   * @type {ClassTypeRefWithName}
   * @memberof ClassTypeDTO
   */
  classOverkill?: ClassTypeRefWithNameOptional;
  /**
   *
   * @type {number}
   * @memberof ClassTypeDTO
   */
  sessionCt?: number;
  /**
   *
   * @type {number}
   * @memberof ClassTypeDTO
   */
  sessionLength?: number;
  /**
   *
   * @type {number}
   * @memberof ClassTypeDTO
   */
  signupMax?: number;
  /**
   *
   * @type {number}
   * @memberof ClassTypeDTO
   */
  signupMin?: number;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeDTO
   */
  adminHold?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeDTO
   */
  noLimit?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeDTO
   */
  noSignup?: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassTypeDTO
   */
  cancelledDatetime?: Date;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeDTO
   */
  allowMultiple?: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassTypeDTO
   */
  confirmTemplate?: string;
}

export interface ClassTypeDTO
  extends ClassTypeDTOOptional, ClassTypeInfo, UnifiedClassTypeFull {
  /**
   *
   * @type {number}
   * @memberof ClassTypeDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof ClassTypeDTO
   */
  typeName?: string;
  /**
   *
   * @type {number}
   * @memberof ClassTypeDTO
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeDTO
   */
  prereqMustComplete?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeDTO
   */
  allowTeacher?: boolean;
  /**
   *
   * @type {RatingRefAndName}
   * @memberof ClassTypeDTO
   */
  teachRating?: RatingRefAndName;
  /**
   *
   * @type {RatingRefAndName}
   * @memberof ClassTypeDTO
   */
  ratingPrereq?: RatingRefAndName;
  /**
   *
   * @type {RatingRefAndName}
   * @memberof ClassTypeDTO
   */
  ratingOverkill?: RatingRefAndName;
  /**
   *
   * @type {ClassTypeRefWithName}
   * @memberof ClassTypeDTO
   */
  classPrereq?: ClassTypeRefWithName;
  /**
   *
   * @type {ClassTypeRefWithName}
   * @memberof ClassTypeDTO
   */
  classOverkill?: ClassTypeRefWithName;
  /**
   *
   * @type {number}
   * @memberof ClassTypeDTO
   */
  sessionCt?: number;
  /**
   *
   * @type {number}
   * @memberof ClassTypeDTO
   */
  sessionLength?: number;
  /**
   *
   * @type {number}
   * @memberof ClassTypeDTO
   */
  signupMax?: number;
  /**
   *
   * @type {number}
   * @memberof ClassTypeDTO
   */
  signupMin?: number;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeDTO
   */
  adminHold?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeDTO
   */
  noLimit?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeDTO
   */
  noSignup?: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassTypeDTO
   */
  cancelledDatetime?: Date;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeDTO
   */
  allowMultiple?: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassTypeDTO
   */
  confirmTemplate?: string;
}

export interface ClassTypeDTOTrackedI extends ClassTypeInfoOptional {
  /**
   *
   * @type {number}
   * @memberof ClassTypeDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassTypeDTO
   */
  typeName?: string;
  typeNameIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassTypeDTO
   */
  displayOrder?: number;
  displayOrderIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeDTO
   */
  prereqMustComplete?: boolean;
  prereqMustCompleteIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeDTO
   */
  allowTeacher?: boolean;
  allowTeacherIsSet: boolean;
  /**
   *
   * @type {RatingRefAndName}
   * @memberof ClassTypeDTO
   */
  teachRating?: RatingRefAndNameTrackedI;
  teachRatingIsSet: boolean;
  /**
   *
   * @type {RatingRefAndName}
   * @memberof ClassTypeDTO
   */
  ratingPrereq?: RatingRefAndNameTrackedI;
  ratingPrereqIsSet: boolean;
  /**
   *
   * @type {RatingRefAndName}
   * @memberof ClassTypeDTO
   */
  ratingOverkill?: RatingRefAndNameTrackedI;
  ratingOverkillIsSet: boolean;
  /**
   *
   * @type {ClassTypeRefWithName}
   * @memberof ClassTypeDTO
   */
  classPrereq?: ClassTypeRefWithNameTrackedI;
  classPrereqIsSet: boolean;
  /**
   *
   * @type {ClassTypeRefWithName}
   * @memberof ClassTypeDTO
   */
  classOverkill?: ClassTypeRefWithNameTrackedI;
  classOverkillIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassTypeDTO
   */
  sessionCt?: number;
  sessionCtIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassTypeDTO
   */
  sessionLength?: number;
  sessionLengthIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassTypeDTO
   */
  signupMax?: number;
  signupMaxIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassTypeDTO
   */
  signupMin?: number;
  signupMinIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeDTO
   */
  adminHold?: boolean;
  adminHoldIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeDTO
   */
  noLimit?: boolean;
  noLimitIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeDTO
   */
  noSignup?: boolean;
  noSignupIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassTypeDTO
   */
  cancelledDatetime?: Date;
  cancelledDatetimeIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassTypeDTO
   */
  allowMultiple?: boolean;
  allowMultipleIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassTypeDTO
   */
  confirmTemplate?: string;
  confirmTemplateIsSet: boolean;
}

transformDatesMap.set("ClassTypeDTO", function (model: ClassTypeDTO) {
  const transformDatesteachRating = transformDatesMap.get("RatingRefAndName");
  if (transformDatesteachRating && model.teachRating) {
    transformDatesteachRating(model.teachRating);
  }
  const transformDatesratingPrereq = transformDatesMap.get("RatingRefAndName");
  if (transformDatesratingPrereq && model.ratingPrereq) {
    transformDatesratingPrereq(model.ratingPrereq);
  }
  const transformDatesratingOverkill =
    transformDatesMap.get("RatingRefAndName");
  if (transformDatesratingOverkill && model.ratingOverkill) {
    transformDatesratingOverkill(model.ratingOverkill);
  }
  const transformDatesclassPrereq = transformDatesMap.get(
    "ClassTypeRefWithName",
  );
  if (transformDatesclassPrereq && model.classPrereq) {
    transformDatesclassPrereq(model.classPrereq);
  }
  const transformDatesclassOverkill = transformDatesMap.get(
    "ClassTypeRefWithName",
  );
  if (transformDatesclassOverkill && model.classOverkill) {
    transformDatesclassOverkill(model.classOverkill);
  }
  if (typeof model.cancelledDatetime == "string")
    model.cancelledDatetime = new Date(model.cancelledDatetime);
});

export type ClassTypeDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  typeName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  displayOrder: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  prereqMustComplete: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  allowTeacher: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  teachRating: PropertyMeta<RatingRefAndNameMetaI>;
  //isDate: false
  //isDatetime: false
  ratingPrereq: PropertyMeta<RatingRefAndNameMetaI>;
  //isDate: false
  //isDatetime: false
  ratingOverkill: PropertyMeta<RatingRefAndNameMetaI>;
  //isDate: false
  //isDatetime: false
  classPrereq: PropertyMeta<ClassTypeRefWithNameMetaI>;
  //isDate: false
  //isDatetime: false
  classOverkill: PropertyMeta<ClassTypeRefWithNameMetaI>;
  //isDate: false
  //isDatetime: false
  sessionCt: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  sessionLength: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  signupMax: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  signupMin: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  adminHold: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  noLimit: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  noSignup: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: true
  cancelledDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  allowMultiple: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  confirmTemplate: PropertyMeta<MetaTypeBase<string>>;
}>;

export var ClassTypeDTOMeta: ClassTypeDTOMetaI = {} as ClassTypeDTOMetaI;
ClassTypeDTOMeta = typeMeta("ClassTypeDTO", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  typeName: propertyMeta("typeName", false, false, false, MetaTypesBase.string),
  displayOrder: propertyMeta(
    "displayOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  prereqMustComplete: propertyMeta(
    "prereqMustComplete",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  allowTeacher: propertyMeta(
    "allowTeacher",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  teachRating: propertyMeta(
    "teachRating",
    false,
    false,
    false,
    RatingRefAndNameMeta,
  ),
  ratingPrereq: propertyMeta(
    "ratingPrereq",
    false,
    false,
    false,
    RatingRefAndNameMeta,
  ),
  ratingOverkill: propertyMeta(
    "ratingOverkill",
    false,
    false,
    false,
    RatingRefAndNameMeta,
  ),
  classPrereq: propertyMeta(
    "classPrereq",
    false,
    false,
    false,
    ClassTypeRefWithNameMeta,
  ),
  classOverkill: propertyMeta(
    "classOverkill",
    false,
    false,
    false,
    ClassTypeRefWithNameMeta,
  ),
  sessionCt: propertyMeta(
    "sessionCt",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  sessionLength: propertyMeta(
    "sessionLength",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  signupMax: propertyMeta(
    "signupMax",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  signupMin: propertyMeta(
    "signupMin",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  adminHold: propertyMeta(
    "adminHold",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  noLimit: propertyMeta("noLimit", false, false, false, MetaTypesBase.boolean),
  noSignup: propertyMeta(
    "noSignup",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  cancelledDatetime: propertyMeta(
    "cancelledDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  allowMultiple: propertyMeta(
    "allowMultiple",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  confirmTemplate: propertyMeta(
    "confirmTemplate",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = ClassTypeDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassTypeFullMeta]);
  metaI.assignId.inheritedFrom = UnifiedClassTypeFullMeta.assignId;
  metaI.typeName.inheritedFrom = UnifiedClassTypeFullMeta.typeName;
  metaI.displayOrder.inheritedFrom = UnifiedClassTypeFullMeta.displayOrder;
  metaI.prereqMustComplete.inheritedFrom =
    UnifiedClassTypeFullMeta.prereqMustComplete;
  metaI.allowTeacher.inheritedFrom = UnifiedClassTypeFullMeta.allowTeacher;
  metaI.teachRating.inheritedFrom = UnifiedClassTypeFullMeta.teachRating;
  metaI.ratingPrereq.inheritedFrom = UnifiedClassTypeFullMeta.ratingPrereq;
  metaI.ratingOverkill.inheritedFrom = UnifiedClassTypeFullMeta.ratingOverkill;
  metaI.classPrereq.inheritedFrom = UnifiedClassTypeFullMeta.classPrereq;
  metaI.classOverkill.inheritedFrom = UnifiedClassTypeFullMeta.classOverkill;
  metaI.interfaces = metaI.interfaces.concat([ClassTypeInfoMeta]);
  metaI.sessionCt.inheritedFrom = ClassTypeInfoMeta.sessionCt;
  metaI.sessionLength.inheritedFrom = ClassTypeInfoMeta.sessionLength;
  metaI.signupMax.inheritedFrom = ClassTypeInfoMeta.signupMax;
  metaI.signupMin.inheritedFrom = ClassTypeInfoMeta.signupMin;
  metaI.typeName.inheritedFrom = ClassTypeInfoMeta.typeName;
  metaI.adminHold.inheritedFrom = ClassTypeInfoMeta.adminHold;
  metaI.noLimit.inheritedFrom = ClassTypeInfoMeta.noLimit;
  metaI.noSignup.inheritedFrom = ClassTypeInfoMeta.noSignup;
  metaI.cancelledDatetime.inheritedFrom = ClassTypeInfoMeta.cancelledDatetime;
  metaI.allowMultiple.inheritedFrom = ClassTypeInfoMeta.allowMultiple;
  metaI.confirmTemplate.inheritedFrom = ClassTypeInfoMeta.confirmTemplate;
});

export class ClassTypeDTOTracked
  extends ClassTypeInfoTracked
  implements ClassTypeDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  typeName__I?: string = undefined;
  typeNameIsSet: boolean = false;
  set typeName(v: undefined | string) {
    if (v !== undefined) {
      this.typeName__I = v;
      this.typeNameIsSet = true;
    } else {
      this.typeName__I = v || undefined;
      this.typeNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeName() {
    return this.typeName__I;
  }
  displayOrder__I?: number = undefined;
  displayOrderIsSet: boolean = false;
  set displayOrder(v: undefined | number) {
    if (v !== undefined) {
      this.displayOrder__I = v;
      this.displayOrderIsSet = true;
    } else {
      this.displayOrder__I = v || undefined;
      this.displayOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get displayOrder() {
    return this.displayOrder__I;
  }
  prereqMustComplete__I?: boolean = undefined;
  prereqMustCompleteIsSet: boolean = false;
  set prereqMustComplete(v: undefined | boolean) {
    if (v !== undefined) {
      this.prereqMustComplete__I = v;
      this.prereqMustCompleteIsSet = true;
    } else {
      this.prereqMustComplete__I = v || undefined;
      this.prereqMustCompleteIsSet = false;
    }
    this.changeTracker = true;
  }
  get prereqMustComplete() {
    return this.prereqMustComplete__I;
  }
  allowTeacher__I?: boolean = undefined;
  allowTeacherIsSet: boolean = false;
  set allowTeacher(v: undefined | boolean) {
    if (v !== undefined) {
      this.allowTeacher__I = v;
      this.allowTeacherIsSet = true;
    } else {
      this.allowTeacher__I = v || undefined;
      this.allowTeacherIsSet = false;
    }
    this.changeTracker = true;
  }
  get allowTeacher() {
    return this.allowTeacher__I;
  }
  teachRating__I?: RatingRefAndNameTracked = undefined;
  teachRatingIsSet: boolean = false;
  set teachRating(v: undefined | RatingRefAndNameTracked) {
    if (v !== undefined) {
      this.teachRating__I = v;
      this.teachRatingIsSet = true;
    } else {
      this.teachRating__I = v || undefined;
      this.teachRatingIsSet = false;
    }
    this.changeTracker = true;
  }
  get teachRating() {
    return this.teachRating__I;
  }
  ratingPrereq__I?: RatingRefAndNameTracked = undefined;
  ratingPrereqIsSet: boolean = false;
  set ratingPrereq(v: undefined | RatingRefAndNameTracked) {
    if (v !== undefined) {
      this.ratingPrereq__I = v;
      this.ratingPrereqIsSet = true;
    } else {
      this.ratingPrereq__I = v || undefined;
      this.ratingPrereqIsSet = false;
    }
    this.changeTracker = true;
  }
  get ratingPrereq() {
    return this.ratingPrereq__I;
  }
  ratingOverkill__I?: RatingRefAndNameTracked = undefined;
  ratingOverkillIsSet: boolean = false;
  set ratingOverkill(v: undefined | RatingRefAndNameTracked) {
    if (v !== undefined) {
      this.ratingOverkill__I = v;
      this.ratingOverkillIsSet = true;
    } else {
      this.ratingOverkill__I = v || undefined;
      this.ratingOverkillIsSet = false;
    }
    this.changeTracker = true;
  }
  get ratingOverkill() {
    return this.ratingOverkill__I;
  }
  classPrereq__I?: ClassTypeRefWithNameTracked = undefined;
  classPrereqIsSet: boolean = false;
  set classPrereq(v: undefined | ClassTypeRefWithNameTracked) {
    if (v !== undefined) {
      this.classPrereq__I = v;
      this.classPrereqIsSet = true;
    } else {
      this.classPrereq__I = v || undefined;
      this.classPrereqIsSet = false;
    }
    this.changeTracker = true;
  }
  get classPrereq() {
    return this.classPrereq__I;
  }
  classOverkill__I?: ClassTypeRefWithNameTracked = undefined;
  classOverkillIsSet: boolean = false;
  set classOverkill(v: undefined | ClassTypeRefWithNameTracked) {
    if (v !== undefined) {
      this.classOverkill__I = v;
      this.classOverkillIsSet = true;
    } else {
      this.classOverkill__I = v || undefined;
      this.classOverkillIsSet = false;
    }
    this.changeTracker = true;
  }
  get classOverkill() {
    return this.classOverkill__I;
  }
  sessionCt__I?: number = undefined;
  sessionCtIsSet: boolean = false;
  set sessionCt(v: undefined | number) {
    if (v !== undefined) {
      this.sessionCt__I = v;
      this.sessionCtIsSet = true;
    } else {
      this.sessionCt__I = v || undefined;
      this.sessionCtIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionCt() {
    return this.sessionCt__I;
  }
  sessionLength__I?: number = undefined;
  sessionLengthIsSet: boolean = false;
  set sessionLength(v: undefined | number) {
    if (v !== undefined) {
      this.sessionLength__I = v;
      this.sessionLengthIsSet = true;
    } else {
      this.sessionLength__I = v || undefined;
      this.sessionLengthIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionLength() {
    return this.sessionLength__I;
  }
  signupMax__I?: number = undefined;
  signupMaxIsSet: boolean = false;
  set signupMax(v: undefined | number) {
    if (v !== undefined) {
      this.signupMax__I = v;
      this.signupMaxIsSet = true;
    } else {
      this.signupMax__I = v || undefined;
      this.signupMaxIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupMax() {
    return this.signupMax__I;
  }
  signupMin__I?: number = undefined;
  signupMinIsSet: boolean = false;
  set signupMin(v: undefined | number) {
    if (v !== undefined) {
      this.signupMin__I = v;
      this.signupMinIsSet = true;
    } else {
      this.signupMin__I = v || undefined;
      this.signupMinIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupMin() {
    return this.signupMin__I;
  }
  adminHold__I?: boolean = undefined;
  adminHoldIsSet: boolean = false;
  set adminHold(v: undefined | boolean) {
    if (v !== undefined) {
      this.adminHold__I = v;
      this.adminHoldIsSet = true;
    } else {
      this.adminHold__I = v || undefined;
      this.adminHoldIsSet = false;
    }
    this.changeTracker = true;
  }
  get adminHold() {
    return this.adminHold__I;
  }
  noLimit__I?: boolean = undefined;
  noLimitIsSet: boolean = false;
  set noLimit(v: undefined | boolean) {
    if (v !== undefined) {
      this.noLimit__I = v;
      this.noLimitIsSet = true;
    } else {
      this.noLimit__I = v || undefined;
      this.noLimitIsSet = false;
    }
    this.changeTracker = true;
  }
  get noLimit() {
    return this.noLimit__I;
  }
  noSignup__I?: boolean = undefined;
  noSignupIsSet: boolean = false;
  set noSignup(v: undefined | boolean) {
    if (v !== undefined) {
      this.noSignup__I = v;
      this.noSignupIsSet = true;
    } else {
      this.noSignup__I = v || undefined;
      this.noSignupIsSet = false;
    }
    this.changeTracker = true;
  }
  get noSignup() {
    return this.noSignup__I;
  }
  cancelledDatetime__I?: Date = undefined;
  cancelledDatetimeIsSet: boolean = false;
  set cancelledDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.cancelledDatetime__I = v;
      this.cancelledDatetimeIsSet = true;
    } else {
      this.cancelledDatetime__I = v || undefined;
      this.cancelledDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get cancelledDatetime() {
    return this.cancelledDatetime__I;
  }
  allowMultiple__I?: boolean = undefined;
  allowMultipleIsSet: boolean = false;
  set allowMultiple(v: undefined | boolean) {
    if (v !== undefined) {
      this.allowMultiple__I = v;
      this.allowMultipleIsSet = true;
    } else {
      this.allowMultiple__I = v || undefined;
      this.allowMultipleIsSet = false;
    }
    this.changeTracker = true;
  }
  get allowMultiple() {
    return this.allowMultiple__I;
  }
  confirmTemplate__I?: string = undefined;
  confirmTemplateIsSet: boolean = false;
  set confirmTemplate(v: undefined | string) {
    if (v !== undefined) {
      this.confirmTemplate__I = v;
      this.confirmTemplateIsSet = true;
    } else {
      this.confirmTemplate__I = v || undefined;
      this.confirmTemplateIsSet = false;
    }
    this.changeTracker = true;
  }
  get confirmTemplate() {
    return this.confirmTemplate__I;
  }
  constructor(config?: ClassTypeDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.teachRating?.setIds();

    this.ratingPrereq?.setIds();

    this.ratingOverkill?.setIds();

    this.classPrereq?.setIds();

    this.classOverkill?.setIds();
  }
  assignFrom(
    config: ClassTypeDTOOptional,
    options?: AssignOptions,
  ): ClassTypeDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.typeName && this.typeNameApplyFilter(optionsRequired.filter)) {
      this.typeName = config.typeName;
      if (optionsRequired.unassign) this.typeNameIsSet = false;
      else this.typeNameIsSet = true;
    }
    if (
      config.displayOrder &&
      this.displayOrderApplyFilter(optionsRequired.filter)
    ) {
      this.displayOrder = config.displayOrder;
      if (optionsRequired.unassign) this.displayOrderIsSet = false;
      else this.displayOrderIsSet = true;
    }
    if (
      config.prereqMustComplete &&
      this.prereqMustCompleteApplyFilter(optionsRequired.filter)
    ) {
      this.prereqMustComplete = config.prereqMustComplete;
      if (optionsRequired.unassign) this.prereqMustCompleteIsSet = false;
      else this.prereqMustCompleteIsSet = true;
    }
    if (
      config.allowTeacher &&
      this.allowTeacherApplyFilter(optionsRequired.filter)
    ) {
      this.allowTeacher = config.allowTeacher;
      if (optionsRequired.unassign) this.allowTeacherIsSet = false;
      else this.allowTeacherIsSet = true;
    }
    if (
      config.teachRating &&
      this.teachRatingApplyFilter(optionsRequired.filter)
    ) {
      this.teachRating = new RatingRefAndNameTracked(
        config.teachRating,
        options,
      );
      if (optionsRequired.unassign) this.teachRatingIsSet = false;
      else this.teachRatingIsSet = true;
    }
    if (
      config.ratingPrereq &&
      this.ratingPrereqApplyFilter(optionsRequired.filter)
    ) {
      this.ratingPrereq = new RatingRefAndNameTracked(
        config.ratingPrereq,
        options,
      );
      if (optionsRequired.unassign) this.ratingPrereqIsSet = false;
      else this.ratingPrereqIsSet = true;
    }
    if (
      config.ratingOverkill &&
      this.ratingOverkillApplyFilter(optionsRequired.filter)
    ) {
      this.ratingOverkill = new RatingRefAndNameTracked(
        config.ratingOverkill,
        options,
      );
      if (optionsRequired.unassign) this.ratingOverkillIsSet = false;
      else this.ratingOverkillIsSet = true;
    }
    if (
      config.classPrereq &&
      this.classPrereqApplyFilter(optionsRequired.filter)
    ) {
      this.classPrereq = new ClassTypeRefWithNameTracked(
        config.classPrereq,
        options,
      );
      if (optionsRequired.unassign) this.classPrereqIsSet = false;
      else this.classPrereqIsSet = true;
    }
    if (
      config.classOverkill &&
      this.classOverkillApplyFilter(optionsRequired.filter)
    ) {
      this.classOverkill = new ClassTypeRefWithNameTracked(
        config.classOverkill,
        options,
      );
      if (optionsRequired.unassign) this.classOverkillIsSet = false;
      else this.classOverkillIsSet = true;
    }
    if (config.sessionCt && this.sessionCtApplyFilter(optionsRequired.filter)) {
      this.sessionCt = config.sessionCt;
      if (optionsRequired.unassign) this.sessionCtIsSet = false;
      else this.sessionCtIsSet = true;
    }
    if (
      config.sessionLength &&
      this.sessionLengthApplyFilter(optionsRequired.filter)
    ) {
      this.sessionLength = config.sessionLength;
      if (optionsRequired.unassign) this.sessionLengthIsSet = false;
      else this.sessionLengthIsSet = true;
    }
    if (config.signupMax && this.signupMaxApplyFilter(optionsRequired.filter)) {
      this.signupMax = config.signupMax;
      if (optionsRequired.unassign) this.signupMaxIsSet = false;
      else this.signupMaxIsSet = true;
    }
    if (config.signupMin && this.signupMinApplyFilter(optionsRequired.filter)) {
      this.signupMin = config.signupMin;
      if (optionsRequired.unassign) this.signupMinIsSet = false;
      else this.signupMinIsSet = true;
    }
    if (config.adminHold && this.adminHoldApplyFilter(optionsRequired.filter)) {
      this.adminHold = config.adminHold;
      if (optionsRequired.unassign) this.adminHoldIsSet = false;
      else this.adminHoldIsSet = true;
    }
    if (config.noLimit && this.noLimitApplyFilter(optionsRequired.filter)) {
      this.noLimit = config.noLimit;
      if (optionsRequired.unassign) this.noLimitIsSet = false;
      else this.noLimitIsSet = true;
    }
    if (config.noSignup && this.noSignupApplyFilter(optionsRequired.filter)) {
      this.noSignup = config.noSignup;
      if (optionsRequired.unassign) this.noSignupIsSet = false;
      else this.noSignupIsSet = true;
    }
    if (
      config.cancelledDatetime &&
      this.cancelledDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.cancelledDatetime = config.cancelledDatetime;
      if (optionsRequired.unassign) this.cancelledDatetimeIsSet = false;
      else this.cancelledDatetimeIsSet = true;
    }
    if (
      config.allowMultiple &&
      this.allowMultipleApplyFilter(optionsRequired.filter)
    ) {
      this.allowMultiple = config.allowMultiple;
      if (optionsRequired.unassign) this.allowMultipleIsSet = false;
      else this.allowMultipleIsSet = true;
    }
    if (
      config.confirmTemplate &&
      this.confirmTemplateApplyFilter(optionsRequired.filter)
    ) {
      this.confirmTemplate = config.confirmTemplate;
      if (optionsRequired.unassign) this.confirmTemplateIsSet = false;
      else this.confirmTemplateIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ClassTypeDTOTrackedI {
    const cloned = {} as ClassTypeDTOTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.typeNameIsSetDeep() &&
      this.typeNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeNameIsSet = true;
      cloned.typeName = this.typeName;
    } else {
      //cloned.typeNameIsSet = false
    }
    if (
      this.displayOrderIsSetDeep() &&
      this.displayOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.displayOrderIsSet = true;
      cloned.displayOrder = this.displayOrder;
    } else {
      //cloned.displayOrderIsSet = false
    }
    if (
      this.prereqMustCompleteIsSetDeep() &&
      this.prereqMustCompleteApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.prereqMustCompleteIsSet = true;
      cloned.prereqMustComplete = this.prereqMustComplete;
    } else {
      //cloned.prereqMustCompleteIsSet = false
    }
    if (
      this.allowTeacherIsSetDeep() &&
      this.allowTeacherApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.allowTeacherIsSet = true;
      cloned.allowTeacher = this.allowTeacher;
    } else {
      //cloned.allowTeacherIsSet = false
    }
    if (
      this.teachRatingIsSetDeep() &&
      this.teachRatingApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.teachRatingIsSet = true;
      cloned.teachRating = this.teachRating?.removeUnset(filter);
    } else {
      //cloned.teachRatingIsSet = false
    }
    if (
      this.ratingPrereqIsSetDeep() &&
      this.ratingPrereqApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ratingPrereqIsSet = true;
      cloned.ratingPrereq = this.ratingPrereq?.removeUnset(filter);
    } else {
      //cloned.ratingPrereqIsSet = false
    }
    if (
      this.ratingOverkillIsSetDeep() &&
      this.ratingOverkillApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ratingOverkillIsSet = true;
      cloned.ratingOverkill = this.ratingOverkill?.removeUnset(filter);
    } else {
      //cloned.ratingOverkillIsSet = false
    }
    if (
      this.classPrereqIsSetDeep() &&
      this.classPrereqApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.classPrereqIsSet = true;
      cloned.classPrereq = this.classPrereq?.removeUnset(filter);
    } else {
      //cloned.classPrereqIsSet = false
    }
    if (
      this.classOverkillIsSetDeep() &&
      this.classOverkillApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.classOverkillIsSet = true;
      cloned.classOverkill = this.classOverkill?.removeUnset(filter);
    } else {
      //cloned.classOverkillIsSet = false
    }
    if (
      this.sessionCtIsSetDeep() &&
      this.sessionCtApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionCtIsSet = true;
      cloned.sessionCt = this.sessionCt;
    } else {
      //cloned.sessionCtIsSet = false
    }
    if (
      this.sessionLengthIsSetDeep() &&
      this.sessionLengthApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionLengthIsSet = true;
      cloned.sessionLength = this.sessionLength;
    } else {
      //cloned.sessionLengthIsSet = false
    }
    if (
      this.signupMaxIsSetDeep() &&
      this.signupMaxApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupMaxIsSet = true;
      cloned.signupMax = this.signupMax;
    } else {
      //cloned.signupMaxIsSet = false
    }
    if (
      this.signupMinIsSetDeep() &&
      this.signupMinApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupMinIsSet = true;
      cloned.signupMin = this.signupMin;
    } else {
      //cloned.signupMinIsSet = false
    }
    if (
      this.adminHoldIsSetDeep() &&
      this.adminHoldApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.adminHoldIsSet = true;
      cloned.adminHold = this.adminHold;
    } else {
      //cloned.adminHoldIsSet = false
    }
    if (
      this.noLimitIsSetDeep() &&
      this.noLimitApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.noLimitIsSet = true;
      cloned.noLimit = this.noLimit;
    } else {
      //cloned.noLimitIsSet = false
    }
    if (
      this.noSignupIsSetDeep() &&
      this.noSignupApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.noSignupIsSet = true;
      cloned.noSignup = this.noSignup;
    } else {
      //cloned.noSignupIsSet = false
    }
    if (
      this.cancelledDatetimeIsSetDeep() &&
      this.cancelledDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cancelledDatetimeIsSet = true;
      cloned.cancelledDatetime = this.cancelledDatetime;
    } else {
      //cloned.cancelledDatetimeIsSet = false
    }
    if (
      this.allowMultipleIsSetDeep() &&
      this.allowMultipleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.allowMultipleIsSet = true;
      cloned.allowMultiple = this.allowMultiple;
    } else {
      //cloned.allowMultipleIsSet = false
    }
    if (
      this.confirmTemplateIsSetDeep() &&
      this.confirmTemplateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.confirmTemplateIsSet = true;
      cloned.confirmTemplate = this.confirmTemplate;
    } else {
      //cloned.confirmTemplateIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ClassTypeDTOTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.typeNameApplyFilter(filter)) this.typeNameIsSet = false;

    if (!this.displayOrderApplyFilter(filter)) this.displayOrderIsSet = false;

    if (!this.prereqMustCompleteApplyFilter(filter))
      this.prereqMustCompleteIsSet = false;

    if (!this.allowTeacherApplyFilter(filter)) this.allowTeacherIsSet = false;

    if (!this.teachRatingApplyFilter(filter)) this.teachRatingIsSet = false;
    this.teachRating?.unassignAll(filter);

    if (!this.ratingPrereqApplyFilter(filter)) this.ratingPrereqIsSet = false;
    this.ratingPrereq?.unassignAll(filter);

    if (!this.ratingOverkillApplyFilter(filter))
      this.ratingOverkillIsSet = false;
    this.ratingOverkill?.unassignAll(filter);

    if (!this.classPrereqApplyFilter(filter)) this.classPrereqIsSet = false;
    this.classPrereq?.unassignAll(filter);

    if (!this.classOverkillApplyFilter(filter)) this.classOverkillIsSet = false;
    this.classOverkill?.unassignAll(filter);

    if (!this.sessionCtApplyFilter(filter)) this.sessionCtIsSet = false;

    if (!this.sessionLengthApplyFilter(filter)) this.sessionLengthIsSet = false;

    if (!this.signupMaxApplyFilter(filter)) this.signupMaxIsSet = false;

    if (!this.signupMinApplyFilter(filter)) this.signupMinIsSet = false;

    if (!this.adminHoldApplyFilter(filter)) this.adminHoldIsSet = false;

    if (!this.noLimitApplyFilter(filter)) this.noLimitIsSet = false;

    if (!this.noSignupApplyFilter(filter)) this.noSignupIsSet = false;

    if (!this.cancelledDatetimeApplyFilter(filter))
      this.cancelledDatetimeIsSet = false;

    if (!this.allowMultipleApplyFilter(filter)) this.allowMultipleIsSet = false;

    if (!this.confirmTemplateApplyFilter(filter))
      this.confirmTemplateIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeDTOMeta.assignId,
      ClassTypeDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  typeNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeDTOMeta.typeName,
      ClassTypeDTOMeta,
      this.typeName,
      this,
    );
  }
  typeNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeNameIsSet && this.typeNameApplyFilter(filter)) return true;

    return false;
  }
  displayOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeDTOMeta.displayOrder,
      ClassTypeDTOMeta,
      this.displayOrder,
      this,
    );
  }
  displayOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.displayOrderIsSet && this.displayOrderApplyFilter(filter))
      return true;

    return false;
  }
  prereqMustCompleteApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeDTOMeta.prereqMustComplete,
      ClassTypeDTOMeta,
      this.prereqMustComplete,
      this,
    );
  }
  prereqMustCompleteIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.prereqMustCompleteIsSet &&
      this.prereqMustCompleteApplyFilter(filter)
    )
      return true;

    return false;
  }
  allowTeacherApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeDTOMeta.allowTeacher,
      ClassTypeDTOMeta,
      this.allowTeacher,
      this,
    );
  }
  allowTeacherIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.allowTeacherIsSet && this.allowTeacherApplyFilter(filter))
      return true;

    return false;
  }
  teachRatingApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeDTOMeta.teachRating,
      ClassTypeDTOMeta,
      this.teachRating,
      this,
    );
  }
  teachRatingIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.teachRatingIsSet && this.teachRatingApplyFilter(filter))
      return true;
    return this.teachRating?.anySet(filter) == true;

    return false;
  }
  ratingPrereqApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeDTOMeta.ratingPrereq,
      ClassTypeDTOMeta,
      this.ratingPrereq,
      this,
    );
  }
  ratingPrereqIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ratingPrereqIsSet && this.ratingPrereqApplyFilter(filter))
      return true;
    return this.ratingPrereq?.anySet(filter) == true;

    return false;
  }
  ratingOverkillApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeDTOMeta.ratingOverkill,
      ClassTypeDTOMeta,
      this.ratingOverkill,
      this,
    );
  }
  ratingOverkillIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ratingOverkillIsSet && this.ratingOverkillApplyFilter(filter))
      return true;
    return this.ratingOverkill?.anySet(filter) == true;

    return false;
  }
  classPrereqApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeDTOMeta.classPrereq,
      ClassTypeDTOMeta,
      this.classPrereq,
      this,
    );
  }
  classPrereqIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.classPrereqIsSet && this.classPrereqApplyFilter(filter))
      return true;
    return this.classPrereq?.anySet(filter) == true;

    return false;
  }
  classOverkillApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeDTOMeta.classOverkill,
      ClassTypeDTOMeta,
      this.classOverkill,
      this,
    );
  }
  classOverkillIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.classOverkillIsSet && this.classOverkillApplyFilter(filter))
      return true;
    return this.classOverkill?.anySet(filter) == true;

    return false;
  }
  sessionCtApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeDTOMeta.sessionCt,
      ClassTypeDTOMeta,
      this.sessionCt,
      this,
    );
  }
  sessionCtIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionCtIsSet && this.sessionCtApplyFilter(filter)) return true;

    return false;
  }
  sessionLengthApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeDTOMeta.sessionLength,
      ClassTypeDTOMeta,
      this.sessionLength,
      this,
    );
  }
  sessionLengthIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionLengthIsSet && this.sessionLengthApplyFilter(filter))
      return true;

    return false;
  }
  signupMaxApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeDTOMeta.signupMax,
      ClassTypeDTOMeta,
      this.signupMax,
      this,
    );
  }
  signupMaxIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupMaxIsSet && this.signupMaxApplyFilter(filter)) return true;

    return false;
  }
  signupMinApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeDTOMeta.signupMin,
      ClassTypeDTOMeta,
      this.signupMin,
      this,
    );
  }
  signupMinIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupMinIsSet && this.signupMinApplyFilter(filter)) return true;

    return false;
  }
  adminHoldApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeDTOMeta.adminHold,
      ClassTypeDTOMeta,
      this.adminHold,
      this,
    );
  }
  adminHoldIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.adminHoldIsSet && this.adminHoldApplyFilter(filter)) return true;

    return false;
  }
  noLimitApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeDTOMeta.noLimit,
      ClassTypeDTOMeta,
      this.noLimit,
      this,
    );
  }
  noLimitIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.noLimitIsSet && this.noLimitApplyFilter(filter)) return true;

    return false;
  }
  noSignupApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeDTOMeta.noSignup,
      ClassTypeDTOMeta,
      this.noSignup,
      this,
    );
  }
  noSignupIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.noSignupIsSet && this.noSignupApplyFilter(filter)) return true;

    return false;
  }
  cancelledDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeDTOMeta.cancelledDatetime,
      ClassTypeDTOMeta,
      this.cancelledDatetime,
      this,
    );
  }
  cancelledDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.cancelledDatetimeIsSet &&
      this.cancelledDatetimeApplyFilter(filter)
    )
      return true;

    return false;
  }
  allowMultipleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeDTOMeta.allowMultiple,
      ClassTypeDTOMeta,
      this.allowMultiple,
      this,
    );
  }
  allowMultipleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.allowMultipleIsSet && this.allowMultipleApplyFilter(filter))
      return true;

    return false;
  }
  confirmTemplateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassTypeDTOMeta.confirmTemplate,
      ClassTypeDTOMeta,
      this.confirmTemplate,
      this,
    );
  }
  confirmTemplateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.confirmTemplateIsSet && this.confirmTemplateApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.typeNameIsSetDeep(filter)) return true;
    if (this.displayOrderIsSetDeep(filter)) return true;
    if (this.prereqMustCompleteIsSetDeep(filter)) return true;
    if (this.allowTeacherIsSetDeep(filter)) return true;
    if (this.teachRatingIsSetDeep(filter)) return true;
    if (this.ratingPrereqIsSetDeep(filter)) return true;
    if (this.ratingOverkillIsSetDeep(filter)) return true;
    if (this.classPrereqIsSetDeep(filter)) return true;
    if (this.classOverkillIsSetDeep(filter)) return true;
    if (this.sessionCtIsSetDeep(filter)) return true;
    if (this.sessionLengthIsSetDeep(filter)) return true;
    if (this.signupMaxIsSetDeep(filter)) return true;
    if (this.signupMinIsSetDeep(filter)) return true;
    if (this.adminHoldIsSetDeep(filter)) return true;
    if (this.noLimitIsSetDeep(filter)) return true;
    if (this.noSignupIsSetDeep(filter)) return true;
    if (this.cancelledDatetimeIsSetDeep(filter)) return true;
    if (this.allowMultipleIsSetDeep(filter)) return true;
    if (this.confirmTemplateIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
